export function useThemeMode() {
  const colorMode = useColorMode();
  const isLight = computed(() => colorMode.value !== "dark");
  const isDark = computed(() => colorMode.value === "dark");

  return { colorMode, isLight, isDark };
}
